export enum InstallationState {
    Indeterminate = 0,
    NeedsDoorSelection = 1,
    NeedsHandleSelection = 2,
    ConfigurationComplete = 3,
}

